import { Box, Divider, Typography } from '@mui/material';
import ExistingImagesGrid from './ExistingImagesGrid';
import NewImagesGrid from './NewImagesGrid';

export default function ImagesField({
  isEdit,
  saving,
  imgsKeep,
  imgPreviews,
  imgsInputRef,
  onImgsChange,
  onRemoveKeep,
  onMoveKeep,
  onRemoveNew,
}) {
  return (
    <Box>
      <Divider sx={{ my: 1 }} />

      <Typography variant="body2" sx={{ mb: 0.5 }}>
        Images (.png, .jpeg, .jpg, .webp)
      </Typography>

      <input
        ref={imgsInputRef}
        type="file"
        multiple
        accept="image/png,image/jpeg,image/jpg,image/webp"
        onChange={onImgsChange}
        disabled={saving}
      />

      {isEdit && (
        <ExistingImagesGrid
          saving={saving}
          imgsKeep={imgsKeep}
          onRemoveKeep={onRemoveKeep}
          onMoveKeep={onMoveKeep}
        />
      )}

      <NewImagesGrid saving={saving} imgPreviews={imgPreviews} onRemoveNew={onRemoveNew} />
    </Box>
  );
}